import { render, staticRenderFns } from "./FormPrincipalAggregate.vue?vue&type=template&id=58237eca"
import script from "./FormPrincipalAggregate.vue?vue&type=script&lang=js"
export * from "./FormPrincipalAggregate.vue?vue&type=script&lang=js"
import style0 from "./FormPrincipalAggregate.vue?vue&type=style&index=0&id=58237eca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports